<template>
  <link
    rel="stylesheet"
    href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.10.0/css/all.min.css"
    integrity="sha512-PgQMlq+nqFLV4ylk1gwUOgm6CtIIXkKwaIHp/PAIWHzig/lKZSEGKEysh0TCVbHJXCLN7WetD8TFecIky75ZfQ=="
    crossorigin="anonymous"
    referrerpolicy="no-referrer"
  >
  <!-- loader -->
  <div class="fixed left-0 top-0 z-50 size-full bg-white opacity-75">
    <div class="mt-[50vh] flex items-center justify-center">
      <div class="fas fa-circle-notch fa-spin fa-5x text-violet-600" />
    </div>
  </div>
</template>
